import GenericModel from '../generic-model';

export class ProjectExtraCompanyContact extends GenericModel {
  projectId?: number;

  company?: string;
  contact?: string;
}
